import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { LifeInsuranceApplicationStep, PublicClassNames } from 'embed/constants'
const PhoneIcon = require('assets/components/icon-phone.svg')

import { BackButton } from 'embed/components/Application/BackButton'
import { ProgressBar } from 'embed/components/Application/ProgressBar'
import ApplicationSubmitButton from 'embed/components/ApplicationSubmitButton'
import ApplicationSubmitButtonContainer from 'embed/components/ApplicationSubmitButton/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { LifeInsuranceStep, Product } from 'even-ts-static'
const applicationStyles = require('embed/styles/application')
const styles = require('./styles')

import { Spinner } from './Spinner'
import AdvertiserDisclosure from 'ui/multi-product/components/AdvertiserDisclosure'

interface Props {
  backToPreview?: boolean
  children: React.ReactNode | null
  directReferral?: boolean
  disableCTA?: boolean
  handleConsentsToFCRAandTCPA?: () => void
  hideCta?: boolean
  onBackToStepOne: () => void
  isLoading?: boolean
  getOffersCta?: boolean
  onBack: () => void
  onContinue?: () => void
  stepByStepApplicationStep?: LifeInsuranceApplicationStep
  stepByStepApplicationStepIsValid?: boolean
  currentStep: number
  followupStep?: number
  totalNumberOfSteps: number
}

export const StepbystepWrapper: React.SFC<Props> = (props) => {
  const headerLink: React.ReactNode = (
    <ThemeConsumer>
      {({ ctaStyles }) => (
        <div
          className={classnames(
            styles.backButtonContainer,
            css`
              justify-content: ${props.backToPreview && props.directReferral ? 'flex-end' : 'space-between'};
            `,
          )}
        >
          {props.backToPreview ? (
            props.directReferral ? null : (
              <BackButton className={applicationStyles.backToSearch} onClick={props.onBackToStepOne} />
            )
          ) : (
            <BackButton className={applicationStyles.backToSearch} onClick={props.onBack} />
          )}

          <div className={styles.telContainer}>
            <span>Questions?</span>
            <PhoneIcon
              className={classnames(css`
                path {
                  fill: ${ctaStyles?.backgroundColor};
                }
              `)}
            />
            <a
              href="tel:844-755-5327"
              className={classnames(css`
                color: ${ctaStyles?.backgroundColor};
              `)}
            >
              844-755-5327
            </a>
          </div>
        </div>
      )}
    </ThemeConsumer>
  )

  let ctaButton: React.ReactNode
  const isLastStep = props.currentStep === props.totalNumberOfSteps
  if (props.hideCta) {
    ctaButton = null
  } else if (isLastStep) {
    ctaButton = (
      <>
        <ApplicationSubmitButtonContainer product={Product.LifeInsurance} nextStep={LifeInsuranceStep.Results}>
          <div className={applicationStyles.advertiserDisclosure}>
            <AdvertiserDisclosure />
          </div>
          <span className={applicationStyles.consentButtonLabel}>Get Quotes</span>
        </ApplicationSubmitButtonContainer>
      </>
    )
  } else if (props.getOffersCta) {
    ctaButton = (
      <ApplicationSubmitButtonContainer
        fullWidth={true}
        nextStep={LifeInsuranceStep.Results}
        product={Product.LifeInsurance}
      />
    )
  } else if (props.disableCTA === true) {
    ctaButton = null
  } else {
    ctaButton = props.onContinue ? (
      <>
        <ApplicationSubmitButton
          fullWidth={true}
          isValid={props.stepByStepApplicationStepIsValid || false}
          onSubmit={props.onContinue}
        >
          Continue
        </ApplicationSubmitButton>
        <span className={applicationStyles.continueHint}>
          Honest answers help us get you the most accurate quotes and smoothest process.
        </span>
      </>
    ) : null
  }

  return (
    <ThemeConsumer>
      {({ backdropStyles, borderRadiusLarge, boxStyles, colorBorder }) => (
        <React.Fragment>
          <div
            className={classnames(
              PublicClassNames.ApplicationContainer,
              applicationStyles.container,
              styles.application,
              css`
                background-color: ${backdropStyles.backgroundColor};
                border-color: ${colorBorder};
                border-radius: ${borderRadiusLarge};
              `,
              {
                [styles.spinnerContainer]: props.isLoading,
                [styles.routerQuestionsContainer]:
                  props.stepByStepApplicationStep === LifeInsuranceApplicationStep.RouterQuestions,
              },
            )}
            style={boxStyles}
          >
            {props.isLoading ? (
              <Spinner />
            ) : (
              <>
                <div className={classnames(applicationStyles.applicationHeader, styles.applicationHeader)}>
                  <div className={applicationStyles.advertiserDisclosure}>
                    <AdvertiserDisclosure />
                  </div>
                  {headerLink}
                </div>
                <ProgressBar
                  totalNumberOfSteps={props.totalNumberOfSteps}
                  currentStep={props.currentStep}
                  followupStep={props.followupStep}
                  followupIncrement={0.09}
                  className={styles.progressBar}
                />
                {props.children === null ? null : (
                  <>
                    <section className={applicationStyles.formSection}>
                      <div className={applicationStyles.centeredField}>{props.children}</div>
                    </section>
                    {ctaButton}
                  </>
                )}
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </ThemeConsumer>
  )
}
